<template>
    <div>
      <div class="d-flex justify-content-between">
        <div>
          <div class="section-title">
            {{ $tc("Fnb Stations", 2) }}
          </div>
       
        </div>
        <div>
          <b-button
           
            variant="default"
            class="btn-blue"
            @click="goToRoute('/fnb/add-fnb-stations',{})"
            >{{ $t("add") }}</b-button
          >
        </div>
      </div>
  
      <div class="d-flex justify-content-between align-items-center my-3">
        <div>
          <!-- <b-form-input
            v-debounce:300="searchCinemasList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input> -->
        </div>
        <div class="d-flex"></div>
        <div class="d-flex align-items-center">
          <div>
            <!-- <select
              v-model="selectedStatus"
              @change="handleStatusChange"
              style="height: 35px; border-radius: 10px"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="all">All</option>
            </select> -->
            <FilterByStatusDropdown
              :onSelect="
                (filterIsActive) => {
                  handleChange(filterIsActive);
                }
              "
            />
          </div>
          <div class="mx-2">
            <b-dropdown name="listview" id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <!-- {{ $t("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
  
          <button
            v-if="GridViewFlag"
            class="btnj btn-gridView mr-3"
            :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"
          ></button>
          <button
            v-if="GridViewFlag"
            class="btnj btn-listView"
            :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"
          ></button>
        </div>
      </div>
  
      <table class="list-view-table" v-if="listView">
        <thead>
          <tr>
            <th class="text-left" style="width: 200px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          
            <th style="width: 200px" >
              {{ $tc("Station ", 1) }}
            </th>
            <th>
                Delivery(%)
            </th>
            <th colspan="5"></th>
           

          </tr>
        </thead>
        <tbody v-if="stationList.length > 0">
          <tr v-for="(item, key) in stationList" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.station_is_active === 'Y' ? 'active' : 'inactive'"
                />
                <span
                  class="edit-icon ml-4 blue-icon"
                  @click="goToRoute('/fnb/edit-fnb-stations', item)"
                  style="cursor: pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </span>
                <span
                  class="view-icon ml-2 blue-icon"
                  @click="goToRoute('/cinema-manager/view-cinema', item)"
                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </span>
              </div>
            </td>
       
            <td>{{ item.station_name }}</td>
            <td>{{item.delivery_percentage? parseFloat(item.delivery_percentage).toFixed(2):"0.00"}}</td>
            <td></td>
         
          </tr>
        </tbody>
        <tbody v-if="stationList.length == 0">
          <tr>
            <td colspan="4">
         
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
  
  
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </template>
  
  <script>
  import MasterService from "@/services/MasterService";
  import Cinemas from "@/helper/formJSONMaster/Cinemas";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  
  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
    },
    data() {
      return {
        cinema_manager_add_edit_disabled: null,
        cinema_id: null,
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
  
        cine_setting_id: "",
        gridView: false,
        listView: true,
        Methods: Cinemas.Methods,
        stationList: [],
        CinemaSetting: [],
        viewingnumbers: [],
        customErrors: {
          message: "",
        },
        CinemasCopy: [],
        searchValue: "",
        searchKey: "Cinema Name",
        //sorting
        isSort: false,
        isAscending: false,
        columnName: "",
        orderBy: "",
        selectedStatus: "Y",
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.cinema_id = obj;
      let roleid = this.secureStore.get("USINFO").role_id;
      this.cinema_manager_add_edit_disabled = roleid;
      if (true) {
        this.isRoleID = false;
      }
      this.getFnbStationList();
      this.getviewingnumber();
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }
  
        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);
  
        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
  
    
    },
  
    methods: {
      handleChange: function (status) {
        console.log("status=>", status);
        this.selectedStatus = status;
        this.getFnbStationList()
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.onChangePagination();
        }
      },
      onChangePagination: function (event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getFnbStationList()
        } else {
          this.currentPage = event;
          this.getFnbStationList()
        }
      },
      goToRoute: function (path, item) {
        const { station_id } = item;
        this.$router.push({
          path: path,
          query: {
            station_id: station_id,
          },
        });
      },
      onSortValue(columnName, orderBy) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getCinemasList();
      },
      searchCinemasList: function (search) {
        this.getCinemasList(undefined, 1, search);
      },
      getFnbStationList: function () {
        this.Cinemas = [];
        let payload = {
          limit: this.perPage,
          offset:(this.currentPage-1)*this.perPage,
          status:this.selectedStatus
        };
        MasterService.getFnbStations(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.stationList = data.Records;
              
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                  this.selectedvalue = "10";

                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              } else {
                this.customErrors.message = data.message;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
  
      viewType: function (viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbStations/fnbStationsList.vue